import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StatoIncarico } from '../models/stato-incarico';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class StatoIncaricoService extends ResourcefulService<StatoIncarico>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, StatoIncarico);
  }
}
